import fetch from "../utils/fetch";

//收益统计
export const fetchStatistics = () => fetch(`profit/statistics`);

//收益列表
export const fetchEaringsList = ({
  beginTime = "",
  endTime = "",
  pageNum,
  pageSize,
  companyName = "",
  tradeNo = "",
}) =>
  fetch(
    `profit/list?beginTime=${beginTime}&endTime=${endTime}&pageNum=${pageNum}&pageSize=${pageSize}&companyName=${companyName}&tradeNo=${tradeNo}`
  );

//查看订单详情
export const fetchOrderDetails = (tradeNo) =>
  fetch(`profit/order/detail/${tradeNo}`);
